import { initClipboardBS5 } from 'src/application/clipboard'

document.addEventListener('DOMContentLoaded', initClipboardBS5)
